import {useBootstrap} from '@front/hooks';

export function useAppDownloads() {
  const { userIt } = useBootstrap();

  function openIosAppLink() {
    window.open(userIt.value.iosAppLink, '_blank');
  }
  function openAndroidAppLink() {
    window.open(userIt.value.androidAppLink, '_blank');
  }
  function openWindowsDesktopAppLink() {
    window.open(userIt.value.windowsDesktopAppLink, '_blank');
  }
  function openMacX86DesktopAppLink() {
    window.open(userIt.value.macX86DesktopAppLink, '_blank');
  }
  function openMacArmDesktopAppLink() {
    window.open(userIt.value.macArmDesktopAppLink, '_blank');
  }
  function openWebLink() {
    window.open(userIt.value.webLink, '_blank');
  }
  function openMobileWebLink() {
    console.log('open h5link:'+userIt.value.h5Link);
    window.open(userIt.value.h5Link, '_blank');
  }

  return {
    openIosAppLink,
    openAndroidAppLink,
    openWindowsDesktopAppLink,
    openMacX86DesktopAppLink,
    openMacArmDesktopAppLink,
    openWebLink,
    openMobileWebLink,
  };
}
